import { IPbrInputProps } from "../PbrInput/PbrInput";
import * as React from "react";
import { PbrInputMask } from "../PbrInput/PbrInputMask";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { useState } from "react";

export function PbrInputPercentage(
  props: {
    onChange?: (floatvalue: number) => void;
    formWrapper: WrappedFormUtils;
    isRequired?: boolean;
    requiredMessage?: string;
    placeholder: string;
    mask?: string;
  } & IPbrInputProps
) {

  const state = { ...props };
  const value = props.value
    ? props.value
      .toString()
      .replace("%", "")
      .padStart(5, "0") // Inclui 0 a esquerda em todas as exibições
    : "";
  const monetaryMask = props.mask ?? "99.99%";

  const [mask, setMask] = useState(monetaryMask);

  function handleChange(e) {
    let num = e.target.value.replace("%", "").toString();
    num = num.slice(0, num.indexOf(".") + 3);
    props.onChange(Number(num / 100));
  }

  delete state.value;
  delete state.onChange;

  return (
    <PbrInputMask
      placeholder={props.placeholder}
      mask={mask}
      disabled={true}
      onKeyDown={e => setMask(monetaryMask)}
      maskChar={null}
      rules={[
        {
          required: props.isRequired,
          message: props.requiredMessage
        }
      ]}
      {...state}
      onChange={handleChange}
      value={Number(value) !== 0 ? value : ""}
    />
  );
}


// WEBPACK FOOTER //
// ./src/components/common/PbrInputPercentageCalculator/PbrInputPercentage.tsx